import React, { Component } from "react"
import { withRouter } from "react-router"
import { Divider } from "antd"
import { Button, Form, Input, Modal } from "semantic-ui-react"
import styled from "styled-components"
import { postLogin } from "../api/sync/index"
import SocialLogin from "../components/SocialButton/index"

const Column = styled.div.attrs({
  className: "column"
})`
  max-width: 700px;
`

const StyledSignUpDiv = styled.div.attrs({
  className: "ui message mobile-mr10 mobile-ml10"
})`
  &&& {
    margin-bottom: 15px;
  }
`

class Login extends Component {
  state = {
    email: "",
    password: ""
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = () => {
    const { email, password } = this.state
    postLogin(email.toLowerCase(), password).then(() => this.props.setLogin())
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        closeOnEscape={this.props.closeOnEscape}
        closeOnDimmerClick={this.props.closeOnDimmerClick}
      >
        <div className="ui column centered grid">
          <Column>
            <div style={{ textAlign: "center", marginBottom: 10 }}>
              <h2 className="ui teal image header mt10 mobile-ml15">
                เข้าสู่ระบบ
              </h2>
            </div>
            <SocialLogin
              next={this.props.next}
              onClose={this.props.onClose}
              setLogin={this.props.setLogin}
            />
            <Divider>Or, use my email address</Divider>
            <Form className="ui large form" onSubmit={this.handleSubmit}>
              <div className="ui stacked segment" style={{ marginTop: 0 }}>
                <Form.Field>
                  <Input
                    name="email"
                    icon="user"
                    iconPosition="left"
                    placeholder="อีเมล/หมายเลขโทรศัพท์"
                    onChange={this.handleChange}
                  />
                </Form.Field>
                <Form.Field>
                  <Input
                    name="password"
                    icon="lock"
                    iconPosition="left"
                    type="password"
                    placeholder="Password"
                    onChange={this.handleChange}
                  />
                </Form.Field>
                <Button className="ui fluid large teal" type="submit">
                  Login
                </Button>
              </div>
              <div className="ui error message" />
            </Form>
            <StyledSignUpDiv>
              ยังไม่ได้เป็นสมาชิก?{" "}
              <a
                href="#"
                onClick={() => {
                  this.props.onClose()
                  this.props.toggleSignup()
                }}
              >
                สมัครสมาชิกเลย
              </a>
              <div
                onClick={() => {
                  this.props.onClose()
                  this.props.history.push("/reset-password")
                }}
              >
                <a href="#">ลืมรหัสผ่าน?</a>
              </div>
            </StyledSignUpDiv>
          </Column>
        </div>
      </Modal>
    )
  }
}

export default withRouter(Login)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Login.js